<template>
  <v-container fluid class="mt-5">
    <v-row class="mb-8">
      <v-col>
        <h2>Dashboard de ISFP/PSFP</h2>
      </v-col>
    </v-row>

    <v-tabs v-model="tab" fixed-tabs color="primary">
      <v-tab :disabled="algumaAbaCarregando">Geral</v-tab>
      <v-tab :disabled="algumaAbaCarregando">Tendência</v-tab>
      <v-tab :disabled="algumaAbaCarregando">Detalhamento</v-tab>
      <v-tab :disabled="algumaAbaCarregando">Visão Brasil</v-tab>
      <v-tab :disabled="algumaAbaCarregando">Simulador</v-tab>
    </v-tabs>

    <v-card class="my-0 mb-5 parametros-v-card">
      <v-card-title>
        <h4>Parâmetros</h4>
      </v-card-title>

      <v-card-text>
        <v-row class="mx-auto mt-3" align="center" justify="space-between">
          <v-col
            v-if="tab !== 1"
            cols="auto"
          >
            <v-chip-group
              :value="modoPeriodo"
              mandatory
              active-class="primary--text primary lighten-5"
              :disabled="loadingAtual"
              @change="setModoPeriodo"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-chip
                    value="ano_civil"
                    outlined
                    v-on="on"
                    :disabled="loadingAtual"
                  >
                    <v-icon left small>mdi-calendar</v-icon>
                    Ano Civil
                  </v-chip>
                </template>
                <span>Meses disponíveis do ano selecionado</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-chip
                    value="12m"
                    outlined
                    v-on="on"
                    :disabled="loadingAtual"
                  >
                    <v-icon left small>mdi-calendar-range</v-icon>
                    12 Meses
                  </v-chip>
                </template>
                <span>Últimos 12 meses a partir da competência</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-chip
                    value="1m"
                    outlined
                    v-on="on"
                    :disabled="loadingAtual"
                  >
                    <v-icon left small>mdi-calendar</v-icon>
                    1 Mês
                  </v-chip>
                </template>
                <span>Abrange dados de 1 único mês</span>
              </v-tooltip>
            </v-chip-group>
          </v-col>

          <v-spacer />

          <v-col
            v-if="modoPeriodo === '12m' || modoPeriodo === '1m' || tab === 1"
            cols="12"
            sm="3"
            class="competencia-input"
          >
            <input-month
              label="Competência"
              rules="min:7"
              :minMonth="'2023-01'"
              :selectedMonth="competencia"
              :disabled="loadingAtual"
              @monthSelected="setCompetencia"
            />
          </v-col>

          <v-col
            v-if="modoPeriodo === 'ano_civil' && tab !== 1"
            cols="12"
            sm="3"
          >
            <v-select
              label="Ano"
              :items="listaAnos"
              :value="ano"
              dense
              hide-details
              :disabled="loadingAtual"
              @change="setAno($event)"
            />
          </v-col>
        </v-row>

        <v-row v-if="tab === 3" class="mx-auto mt-3" align="center">
          <v-col cols="12" sm="2">
            <v-select
              :value="filtrosVisaoBrasil.tipoOutorga"
              :items="opcoesOutorga"
              item-text="text"
              item-value="value"
              label="P/C"
              dense
              hide-details
              :disabled="loadingAtual"
              @change="updateFiltroPai('tipoOutorga', $event)"
            />
          </v-col>

          <v-col cols="12" sm="3">
            <v-autocomplete
              :value="filtrosVisaoBrasil.grupoEconomico"
              :items="opcoesGrupoEconomico"
              item-text="text"
              item-value="value"
              label="Grupo Econômico"
              dense
              hide-details
              :disabled="loadingAtual"
              @change="updateFiltroPai('grupoEconomico', $event)"
            />
          </v-col>

          <v-col cols="12" sm="2">
            <v-autocomplete
              :value="filtrosVisaoBrasil.uf"
              :items="opcoesEstado"
              item-text="text"
              item-value="value"
              label="Estado"
              dense
              hide-details
              :disabled="loadingAtual"
              @change="updateFiltroPai('uf', $event)"
            />
          </v-col>

          <v-col cols="12" sm="2">
            <v-select
              :value="filtrosVisaoBrasil.regiao"
              :items="opcoesRegiao"
              item-text="text"
              item-value="value"
              label="Região"
              dense
              hide-details
              :disabled="loadingAtual"
              @change="updateFiltroPai('regiao', $event)"
            />
          </v-col>

          <v-col cols="12" sm="3" class="d-flex align-end">
            <v-btn
              color="primary"
              block
              :loading="loadingAtual"
              :disabled="loadingAtual"
              @click="aplicarFiltrosVisaoBrasil"
            >
              Aplicar filtros
            </v-btn>
          </v-col>
        </v-row>

        <select-indices
          v-if="tab === 2"
          :defaultIndices="indicesSelecionados"
          :disabled="loadingAtual"
          @update:selectedIndices="indicesSelecionados = $event"
          @update:selectedServicos="setServicosSelecionados($event)"
        />
      </v-card-text>

      <v-progress-linear
        v-if="loadingAtual"
        color="primary"
        indeterminate
        height="4"
        class="my-0"
      />
    </v-card>

    <dashboard-isfp-psfp-geral
      v-if="tab === 0 && competencia != null && competencia !== ''"
      :competencia="competencia"
      :modoPeriodo="modoPeriodo"
      :ano="modoPeriodo === 'ano_civil' ? ano : null"
      :activatedTab="tab"
      :reloadKey="reloadGeralKey"
      :parcela-b-loading="loadingParcelaB"
      :parcela-b-disabled="loadingAtual || loadingParcelaB"
      @updateLoadingDados="loadingTabs.geral = $event"
      @navegarParaDetalhamento="onNavegaarParaDetalhamento"
      @abrir-parcela-b="abrirModalParcelaB"
    />

    <dashboard-isfp-psfp-tendencia
      v-if="tab === 1 && competencia != null && competencia !== ''"
      :activatedTab="tab"
      :competencia="competencia"
      @updateLoadingDados="loadingTabs.tendencia = $event"
    />

    <dashboard-isfp-psfp-detalhamento
      v-if="tab === 2 && competencia != null && competencia !== ''"
      :competencia="competencia"
      :modoPeriodo="modoPeriodo"
      :ano="modoPeriodo === 'ano_civil' ? ano : null"
      :activatedTab="tab"
      :servicosSelecionados="servicosSelecionados"
      :categoriasServicosSelecionadas="categoriasServicosSelecionadas"
      :indicesSelecionados="indicesSelecionados"
      :codigoPreSelecionado="codigoServicoPreSelecionado"
      @updateLoadingDados="loadingTabs.detalhamento = $event"
    />

    <dashboard-isfp-psfp-visao-brasil
      v-if="tab === 3"
      :activatedTab="tab"
      :competencia="competencia"
      :modoPeriodo="modoPeriodo"
      :ano="modoPeriodo === 'ano_civil' ? ano : null"
      :filtros="filtrosVisaoBrasil"
      :reloadKey="reloadVisaoBrasilKey"
      @updateLoadingFiltrosVisaoBrasil="loadingTabs.visaoBrasil = $event"
    />

    <dashboard-isfp-psfp-simulador
      v-if="tab === 4 && competencia != null && competencia !== ''"
      :competencia="competencia"
      :modoPeriodo="modoPeriodo"
      :ano="modoPeriodo === 'ano_civil' ? ano : null"
      :activatedTab="tab"
      :reloadKey="reloadGeralKey"
      :parcela-b-loading="loadingParcelaB"
      :parcela-b-disabled="loadingAtual || loadingParcelaB"
      @updateLoadingDados="loadingTabs.simulador = $event"
      @navegarParaDetalhamento="onNavegaarParaDetalhamento"
      @abrir-parcela-b="abrirModalParcelaB"
    />

    <v-dialog v-model="dialogParcelaB" max-width="420">
      <v-card>
        <v-card-title>
          <h4>Informar/Atualizar</h4>
        </v-card-title>

        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="mb-5 display-1">
              Valor atual:
              <strong>
                {{ parcelaBDisplay || "NA" | parseNumberToFloatBrIgnoringNaN }}
              </strong>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="parcelaBInput"
                label="Parcela B"
                dense
                outlined
                hide-details
                type="number"
                prefix="R$"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialogParcelaB = false">
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            :loading="salvandoParcelaB"
            @click="salvarParcelaB"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DashboardIsfpPsfpService from "@/services/DashboardIsfpPsfpService";

const opcao_todos = { text: "Todos", value: null };

export default {
  name: "DashboardISfpPsFp",
  components: {
    InputMonth: () => import("@/components/general/InputMonth.vue"),
    SelectIndices: () => import("@/components/general/SelectIndices.vue"),
    DashboardIsfpPsfpGeral: () =>
      import("@/components/dashboardIsfpPsfp/DashboardIsfpPsfpGeral.vue"),
    DashboardIsfpPsfpTendencia: () =>
      import("@/components/dashboardIsfpPsfp/DashboardIsfpPsfpTendencia.vue"),
    DashboardIsfpPsfpDetalhamento: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpDetalhamento.vue"
      ),
    DashboardIsfpPsfpVisaoBrasil: () =>
      import("@/components/dashboardIsfpPsfp/DashboardIsfpPsfpVisaoBrasil.vue"),
    DashboardIsfpPsfpSimulador: () =>
      import("@/components/dashboardIsfpPsfp/DashboardIsfpPsfpSimulador.vue"),
  },

  data: () => ({
    tab: 0,
    loadingTabs: {
      geral: false,
      tendencia: false,
      detalhamento: false,
      visaoBrasil: false,
      simulador: false,
    },
    dialogParcelaB: false,
    loadingParcelaB: false,
    salvandoParcelaB: false,
    parcelaBInput: null,
    parcelaBDisplay: null,
    reloadGeralKey: 0,
    codigoServicoPreSelecionado: null,
    indicesSelecionados: [],
    opcoesOutorga: [],
    opcoesGrupoEconomico: [],
    opcoesEstado: [],
    opcoesRegiao: [],
    reloadVisaoBrasilKey: 0,
    loadingOpcoesVisaoBrasil: false,
    opcoesVisaoBrasilCarregadas: false,
  }),

  beforeMount() {
    this.setRangeCompetencias();
  },

  watch: {
    tab(novo) {
      if (novo === 3 && !this.opcoesVisaoBrasilCarregadas) {
        this.carregarFiltrosVisaoBrasil();
      }
    },
  },

  computed: {
    ...mapState("parametrosDashboardIsfpPsfp", [
      "competencia",
      "modoPeriodo",
      "ano",
      "servicosSelecionados",
      "categoriasServicosSelecionadas",
      "filtrosVisaoBrasil",
    ]),

    listaAnos() {
      const anoAtual = new Date().getFullYear();
      const anos = [];
      for (let a = anoAtual; a >= 2023; a--) {
        anos.push(a);
      }
      return anos;
    },

    loadingAtual() {
      if (this.tab === 0) return this.loadingTabs.geral;
      if (this.tab === 1) return this.loadingTabs.tendencia;
      if (this.tab === 2) return this.loadingTabs.detalhamento;
      if (this.tab === 3) {
        return this.loadingTabs.visaoBrasil || this.loadingOpcoesVisaoBrasil;
      }
      if(this.tab === 4) return this.loadingTabs.simulador;
      return false;
    },

    algumaAbaCarregando() {
      return (
        Object.values(this.loadingTabs).some(Boolean) ||
        this.loadingOpcoesVisaoBrasil
      );
    },
  },

  methods: {
    ...mapActions("parametrosDashboardIsfpPsfp", [
      "setRangeCompetencias",
      "setCompetencia",
      "setModoPeriodo",
      "setAno",
      "setServicosSelecionados",
      "setCategoriasServicosSelecionadas",
      "setServicoSelecionado",
      "setFiltrosVisaoBrasil",
    ]),

    async abrirModalParcelaB() {
      this.loadingParcelaB = true;

      try {
        const response = await DashboardIsfpPsfpService.getParcelaB();
        this.parcelaBInput =
          response?.parcela_b !== null && response?.parcela_b !== undefined
            ? response.parcela_b
            : null;
        this.parcelaBDisplay = this.parcelaBInput;

        this.dialogParcelaB = true;
      } catch (error) {
        console.error("Erro ao carregar Parcela B:", error);
        this.$toast.error("Erro ao carregar Parcela B.", "", {
          position: "topRight",
        });
      } finally {
        this.loadingParcelaB = false;
      }
    },

    async salvarParcelaB() {
      this.salvandoParcelaB = true;

      try {
        await DashboardIsfpPsfpService.salvarParcelaB(this.parcelaBInput);

        this.dialogParcelaB = false;
        this.reloadGeralKey += 1;

        this.$toast.success("Parcela B salva com sucesso.", "", {
          position: "topRight",
        });
      } catch (error) {
        console.error("Erro ao salvar Parcela B:", error);
        this.$toast.error("Erro ao salvar Parcela B.", "", {
          position: "topRight",
        });
      } finally {
        this.salvandoParcelaB = false;
      }
    },

    aplicarFiltrosVisaoBrasil() {
      this.reloadVisaoBrasilKey += 1;
    },

    async carregarFiltrosVisaoBrasil() {
      this.loadingOpcoesVisaoBrasil = true;

      try {
        const response = await DashboardIsfpPsfpService.getFiltrosVisaoBrasil();

        const tiposOutorga =
          response?.tipos_outorga || response?.tipos_ortuga || [];
        const gruposEconomicos = response?.grupos_economicos || [];
        const estados = response?.estados || [];
        const regioes = response?.regioes || [];

        this.opcoesOutorga = [
          opcao_todos,
          ...tiposOutorga.map((item) => ({
            text: item,
            value: item,
          })),
        ];

        this.opcoesGrupoEconomico = [
          opcao_todos,
          ...gruposEconomicos.map((item) => ({
            text: item,
            value: item,
          })),
        ];

        this.opcoesEstado = [
          opcao_todos,
          ...estados.map((item) => ({
            text: item.estado,
            value: item.uf,
          })),
        ];

        this.opcoesRegiao = [
          opcao_todos,
          ...regioes.map((item) => ({
            text: item,
            value: item,
          })),
        ];

        this.opcoesVisaoBrasilCarregadas = true;
      } catch (error) {
        console.error("Erro ao carregar filtros da Visão Brasil:", error);
        this.$toast.error("Erro ao carregar filtros da Visão Brasil.", "", {
          position: "topRight",
        });
        this.opcoesOutorga = [opcao_todos];
        this.opcoesGrupoEconomico = [opcao_todos];
        this.opcoesEstado = [opcao_todos];
        this.opcoesRegiao = [opcao_todos];
      } finally {
        this.loadingOpcoesVisaoBrasil = false;
      }
    },

    updateFiltroPai(campo, valor) {
      this.setFiltrosVisaoBrasil({
        ...this.filtrosVisaoBrasil,
        [campo]: valor ?? null,
      });
    },

    onNavegaarParaDetalhamento(codigoServico) {
      this.codigoServicoPreSelecionado = codigoServico;
      this.$nextTick(() => {
        this.tab = 2;
      });
    },
  },
};
</script>

<style>
.parametros-v-card {
  box-shadow: 0px 0px 0px !important;
}
</style>
